module.exports = __webpack_public_path__ + "img/img_hmi_lcd_display.5e64003b.jpg";